import { useContext, useEffect, useMemo, useState } from "react";

import ToolbarButton from "../toolbar/ToolbarButton";
import { DrawingContext, DrawingFeatureType, DrawingMode } from "../../contexts/DrawingContext";
import type { Layer } from "../../types/layer";

const MeasureLayer = (id: string, name: string): Layer => {
  const {
    coords,
    drawingMode,
    setDrawingMode,
    drawingFeatureType,
    setDrawingFeatureType,
    geojson,
    setGeojson,
  } = useContext(DrawingContext);
  const [stale, setStale] = useState(false);

  useEffect(() => {
    if (drawingMode !== DrawingMode.MEASURE) return;
    if (drawingFeatureType !== DrawingFeatureType.LINE) {
      setDrawingFeatureType(DrawingFeatureType.LINE);
    }
  }, [drawingMode, drawingFeatureType, setDrawingFeatureType]);

  useEffect(() => {
    if (drawingMode !== DrawingMode.MEASURE) return;

    const nextGeojson = {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          properties: {},
          geometry: {
            type: "LineString",
            coordinates: coords,
          },
        },
      ],
    };

    setGeojson(nextGeojson as any);
  }, [coords, drawingMode, setGeojson]);

  useEffect(() => {
    if (geojson && drawingMode === DrawingMode.MEASURE) {
      setStale(true);
    }
  }, [geojson, drawingMode]);

  const layerStyle = useMemo(
    () => ({
      id,
      type: "line",
      paint: {
        "line-color": "#22c55e",
        "line-width": 3,
      },
    }),
    [id]
  );

  const toolbarButton = (
    <ToolbarButton
      key={id}
      id={id}
      name={name}
      icon={"straighten"}
      toggledOn={drawingMode === DrawingMode.MEASURE}
      enabled={true}
      onClick={() => {
        if (drawingMode === DrawingMode.MEASURE) {
          setDrawingMode(DrawingMode.NONE);
          setDrawingFeatureType(DrawingFeatureType.NONE);
          return;
        }
        setDrawingMode(DrawingMode.MEASURE);
        setDrawingFeatureType(DrawingFeatureType.LINE);
      }}
      labelSide={"right"}
    />
  );

  return {
    id,
    type: "drawing-layer",
    name,
    source: geojson,
    layerStyle,
    toolbarButton,
    active: drawingMode === DrawingMode.MEASURE,
    stale,
    setStale,
  };
};

export default MeasureLayer;
